export default [
  {
    title: 'จัดการข้อมูล การเติมเงิน',
    route: 'creditManagement',
    icon: 'CreditCardIcon',
    action: 'all',
    resource: 'admin',
  },
]
